var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ab-parallelogram",class:[{ [`ab-parallelogram--${_vm.color}`]: _vm.color }]})
}
var staticRenderFns = []

export { render, staticRenderFns }